export default "__VITE_ASSET__DdUNL4GV__"